import Vue from "vue";

const store = () => window.$store;
const { fb, fbBase, fbusersbase } = require('../util').default.fb();
const mu = require('../mutations').default;

const t = true;

function validateFirebasePath(obj, maxLength = 1500) {
  if (typeof obj !== "object" || obj === null) return obj;

  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    if (typeof key === "string" && key.length > maxLength) {
      console.warn(
        `Firebase property path too long (${key.length} chars), truncating to ${maxLength} bytes`
      );
      const truncatedKey = key.substring(0, maxLength);
      result[truncatedKey] = value;
    } else {
      result[key] = value;
    }
  }
  return result;
}

// Helper function to send email via cloud function
async function sendEmail(toEmail, subject, html, text, fromName = 'XMBL', fromEmail = 'agent@xmbl.org') {
  const store = window.$store;
  const cloudurl = store.state.cloudurl || 'https://us-central1-xmba-cloud-api.cloudfunctions.net/';
  
  try {
    const response = await fetch(cloudurl + 'sendmail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Origin': window.location.origin
      },
      body: JSON.stringify({
        subject: subject,
        from: {
          name: fromName,
          address: fromEmail
        },
        to: [{
          name: '',
          address: toEmail
        }],
        html: html,
        text: text
      })
    });
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Unknown error' }));
      // Only log actual email sending errors, not Firestore logging errors
      if (response.status >= 500) {
        console.error('Email send error:', error);
        return false;
      }
      // For 4xx errors, still log but return false
      console.log('Email send warning (non-critical):', error);
      return false;
    }
    // Success - email was sent
    return true;
  } catch (error) {
    // Don't show errors for network issues if email might have been sent
    console.error('Error sending email:', error);
    return false;
  }
}

// Helper function to get user email
async function getUserEmail(userId) {
  const store = window.$store;
  try {
    const email = await store.dispatch('query', { type: 'email', id: userId });
    return email;
  } catch (error) {
    console.error('Error getting user email:', error);
    // Fallback to auth email if available
    const auth = store.state.auth;
    if (auth && auth.email) return auth.email;
    return null;
  }
}

async function update(state, payload) {
  console.log("update", payload);
  if (!store().state.auth.uid) {
    store().state.show.auth = t;
    return console.log("Must be logged in", "Please authenticate.");
  }
  const st = store().state;
  payload.id =
    payload.type === "user"
      ? payload.id ||
        payload.uid ||
        payload.mId ||
        payload.fId ||
        payload.data.id
      : payload.id || store().state.auth.uid;

  const methods = {
    app: async (payload) => {
      !payload.data.user
        ? (payload.data.user = [store().state.auth.uid])
        : void 0;
      
      // Handle payments section - encrypt stripe key and save to api.xmbl.org
      if (payload.data.payments && payload.data.payments["stripe-key"]) {
        const stripeKey = payload.data.payments["stripe-key"];
        const database = store().state.app.basics.database || 'xmbl';
        
        try {
          // Encrypt the stripe key
          const cloudurl = store().state.cloudurl || 'https://us-central1-xmba-cloud-api.cloudfunctions.net/';
          const encryptResponse = await fetch(cloudurl + 'encryptkey-encrypt', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ key: stripeKey })
          });
          
          if (!encryptResponse.ok) {
            throw new Error('Failed to encrypt stripe key');
          }
          
          const encryptData = await encryptResponse.json();
          const encryptedKey = encryptData.encrypted;
          
          // Save to api.xmbl.org/keys/set
          // For site-wide keys, use database name as userId
          const keysApiUrl = 'https://api.xmbl.org/keys/set';
          const keysPayload = {
            [database]: {
              [database]: {
                stripe: encryptedKey
              }
            }
          };
          
          const keysResponse = await fetch(keysApiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(keysPayload)
          });
          
          if (!keysResponse.ok) {
            const errorText = await keysResponse.text();
            throw new Error(`Failed to save encrypted key: ${errorText}`);
          }
          
          console.log('[PAYMENTS] Stripe key encrypted and saved to api.xmbl.org');
          
          // Remove plaintext key from payload before saving to Firestore
          delete payload.data.payments["stripe-key"];
        } catch (error) {
          console.error('[PAYMENTS] Error encrypting/saving stripe key:', error);
          // Remove the key from payload even if encryption failed
          delete payload.data.payments["stripe-key"];
          // Don't throw - allow the rest of the update to proceed
        }
      }
      
      // Merge payload.data with current app state to ensure both deletions and new changes are reflected
      // The payload.data contains form changes (like new items), while store().state.app has deletions
      const currentAppState = JSON.parse(JSON.stringify(store().state.app));
      
      // Deep merge payload.data into currentAppState
      const deepMerge = (target, source) => {
        for (const key in source) {
          if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            target[key] = target[key] || {};
            deepMerge(target[key], source[key]);
          } else if (Array.isArray(source[key])) {
            // For arrays, replace entirely (this is what we want for basics.items)
            target[key] = source[key];
          } else {
            target[key] = source[key];
          }
        }
        return target;
      };
      
      // Merge payload.data into current app state
      const mergedAppState = payload.data ? deepMerge(currentAppState, payload.data) : currentAppState;
      
      // Update itemTypes array based on basics.items
      if (mergedAppState.basics && mergedAppState.basics.items && Array.isArray(mergedAppState.basics.items)) {
        mergedAppState.itemTypes = mergedAppState.basics.items.map(item => item.name).filter(Boolean);
      }
      
      // Save the merged app state (ensures both deletions and new changes are persisted)
      return fbBase.set({ app: mergedAppState }, { merge: false }).then((x) => {
        payload.reload
          ? window.location.reload()
          : store().commit("set", { keys: ["show", "reinit"], val: t });
        store().commit("set", { key: "app", val: mergedAppState });
        return x;
      });
    },
    orders: async (payload) => {
      return fbBase
        .collection("orders")
        .doc(payload.id)
        .get()
        .then((orderData) => {
          var order = orderData.data();
          var completeCheck = [];
          var sellers = [];
          if (payload.data.item) {
            if (sellers.indexOf(payload.data.item.seller) < 0) {
              sellers.push(payload.data.item.seller);
            }
            order.items.forEach((item, itemKey) => {
              if (
                JSON.stringify(item).indexOf(payload.data.item.iitemid) >
                  -1 &&
                JSON.stringify(item).indexOf(store().state.auth.uid) > -1
              ) {
                order.items[itemKey] = payload.data.item;
                if (order.items[itemKey].status !== "delivered") {
                  completeCheck.push(item.status);
                }
                order.complete = completeCheck.length === 0;
                fbBase
                  .collection("orders")
                  .doc(payload.id)
                  .update(validateFirebasePath(order))
                  .then(() => {
                    const actRef = window.$store._actions;
                    if (actRef.notify) {
                      store().dispatch("notify", {
                        type: "order",
                        text: `${order.items[itemKey].itemTitle} ${order.items[itemKey].status}`,
                        users: [item.buyer],
                        from: store().state.auth.uid,
                        link: `/orders/${payload.id}`,
                        id: payload.id
                      });
                    }
                    
                    // Send email notification to buyer about order status update
                    const orderLink = `${window.location.origin}/orders/${payload.id}`;
                    const appName = (store().state.app && store().state.app.basics && store().state.app.basics["app name"]) || 'XMBL';
                    getUserEmail(item.buyer).then(buyerEmail => {
                      if (buyerEmail) {
                        const html = `
                          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
                            <h1 style="color: #2196F3;">Order Update</h1>
                            <p>Your order on ${appName} has been updated!</p>
                            <div style="background-color: #f5f5f5; padding: 15px; margin: 20px 0; border-radius: 5px;">
                              <p style="margin: 5px 0;"><strong>Order ID:</strong> ${payload.id}</p>
                              <p style="margin: 5px 0;"><strong>Item:</strong> ${order.items[itemKey].itemTitle}</p>
                              <p style="margin: 5px 0;"><strong>Status:</strong> <strong style="color: #2196F3;">${order.items[itemKey].status}</strong></p>
                            </div>
                            <div style="margin: 30px 0; text-align: center;">
                              <a href="${orderLink}" style="background-color: #2196F3; color: white; padding: 12px 24px; text-decoration: none; border-radius: 5px; display: inline-block;">View Order Details</a>
                            </div>
                          </div>
                        `;
                        sendEmail(buyerEmail, `${appName} - Order Update - Order ${payload.id}`, html,
                          `Order Update - Order ${payload.id}\n\nYour order on ${appName} has been updated!\n\nOrder ID: ${payload.id}\nItem: ${order.items[itemKey].itemTitle}\nStatus: ${order.items[itemKey].status}\n\nView: ${orderLink}`, appName).catch(err => {
                          console.log('Email send failed (non-critical):', err);
                        });
                      }
                    });
                    
                    // Send email notification to seller about order status update
                    getUserEmail(item.seller).then(sellerEmail => {
                      if (sellerEmail) {
                        const saleLink = `${window.location.origin}/sales/${payload.id}`;
                        const html = `
                          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
                            <h1 style="color: #2196F3;">Sale Update</h1>
                            <p>Order status on ${appName} has been updated!</p>
                            <div style="background-color: #f5f5f5; padding: 15px; margin: 20px 0; border-radius: 5px;">
                              <p style="margin: 5px 0;"><strong>Order ID:</strong> ${payload.id}</p>
                              <p style="margin: 5px 0;"><strong>Item:</strong> ${order.items[itemKey].itemTitle}</p>
                              <p style="margin: 5px 0;"><strong>Status:</strong> <strong style="color: #2196F3;">${order.items[itemKey].status}</strong></p>
                            </div>
                            <div style="margin: 30px 0; text-align: center;">
                              <a href="${saleLink}" style="background-color: #2196F3; color: white; padding: 12px 24px; text-decoration: none; border-radius: 5px; display: inline-block;">View Sale Details</a>
                            </div>
                          </div>
                        `;
                        sendEmail(sellerEmail, `${appName} - Sale Update - Order ${payload.id}`, html,
                          `Sale Update - Order ${payload.id}\n\nOrder status on ${appName} has been updated!\n\nOrder ID: ${payload.id}\nItem: ${order.items[itemKey].itemTitle}\nStatus: ${order.items[itemKey].status}\n\nView: ${saleLink}`, appName).catch(err => {
                          console.log('Email send failed (non-critical):', err);
                        });
                      }
                    });
                  });
              }
            });
          }
          if (payload.data.paid) {
            // todo create batch transaction instead of so many updates
            order.paid = payload.data.paid;
            Vue.set(
              store().state.user[store().state.auth.uid].auctions,
              order.items[0].type + "_" + order.items[0].iitemid,
              order.id
            );
            store().dispatch("update", {
              type: "user",
              id: store().state.auth.uid,
              data: store().state.user[store().state.auth.uid],
            });
            fbBase
              .collection("orders")
              .doc(payload.id)
              .update(validateFirebasePath(order))
              .then(async () => {
                let item =
                  store().state.items[order.items[0].type][order.items[0].id] ||
                  (await store()
                    .dispatch("query", {
                      type: "item",
                      collection: order.items[0].type,
                      id: order.items[0].iitemid,
                    })
                    .then((i) => i));
                item.purchases.auction
                  ? (item.purchases["auction complete"] = order.id)
                  : null;
                store().dispatch("update", {
                  type: item.type,
                  id: item.id,
                  data: item,
                });
                const appName = (store().state.app && store().state.app.basics && store().state.app.basics["app name"]) || 'XMBL';
                sellers.forEach((seller) => {
                  const actRef = window.$store._actions;
                  if (actRef.notify) {
                    store().dispatch("notify", {
                      type: "sale",
                      text: `Order ${order.id} paid`,
                      users: [seller],
                      from: "transaction",
                      link: `/sales/${payload.id}`,
                      id: payload.id
                    });
                  }
                  
                  // Send email notification to seller about payment
                  const saleLink = `${window.location.origin}/sales/${payload.id}`;
                  getUserEmail(seller).then(sellerEmail => {
                    if (sellerEmail) {
                      const html = `
                        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
                          <h1 style="color: #4CAF50;">Payment Received</h1>
                          <p>Payment has been received for your order on ${appName}!</p>
                          <div style="background-color: #f5f5f5; padding: 15px; margin: 20px 0; border-radius: 5px;">
                            <p style="margin: 5px 0;"><strong>Order ID:</strong> ${order.id}</p>
                            <p style="margin: 5px 0;"><strong>Total Amount:</strong> <strong style="color: #4CAF50; font-size: 1.2em;">$${order.total}</strong></p>
                            <p style="margin: 5px 0;"><strong>Payment Status:</strong> <strong style="color: #4CAF50;">Confirmed</strong></p>
                          </div>
                          <div style="margin: 30px 0; text-align: center;">
                            <a href="${saleLink}" style="background-color: #4CAF50; color: white; padding: 12px 24px; text-decoration: none; border-radius: 5px; display: inline-block;">View Sale Details</a>
                          </div>
                        </div>
                      `;
                      sendEmail(sellerEmail, `${appName} - Payment Received - Order ${order.id}`, html,
                        `Payment Received - Order ${order.id}\n\nPayment has been received for your order on ${appName}!\n\nOrder ID: ${order.id}\nTotal: $${order.total}\nPayment Status: Confirmed\n\nView: ${saleLink}`, appName).catch(err => {
                          console.log('Email send failed (non-critical):', err);
                        });
                    }
                  });
                });
                
                // Send email notification to buyer about payment confirmation
                const orderLink = `${window.location.origin}/orders/${payload.id}`;
                getUserEmail(order.items[0].buyer).then(buyerEmail => {
                  if (buyerEmail) {
                    const html = `
                      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
                        <h1 style="color: #4CAF50;">Payment Confirmed</h1>
                        <p>Your payment on ${appName} has been confirmed!</p>
                        <div style="background-color: #f5f5f5; padding: 15px; margin: 20px 0; border-radius: 5px;">
                          <p style="margin: 5px 0;"><strong>Order ID:</strong> ${order.id}</p>
                          <p style="margin: 5px 0;"><strong>Total Amount:</strong> <strong style="color: #4CAF50; font-size: 1.2em;">$${order.total}</strong></p>
                          <p style="margin: 5px 0;"><strong>Payment Status:</strong> <strong style="color: #4CAF50;">Confirmed</strong></p>
                        </div>
                        <div style="margin: 30px 0; text-align: center;">
                          <a href="${orderLink}" style="background-color: #4CAF50; color: white; padding: 12px 24px; text-decoration: none; border-radius: 5px; display: inline-block;">View Order Details</a>
                        </div>
                      </div>
                    `;
                    sendEmail(buyerEmail, `${appName} - Payment Confirmed - Order ${order.id}`, html,
                      `Payment Confirmed - Order ${order.id}\n\nYour payment on ${appName} has been confirmed!\n\nOrder ID: ${order.id}\nTotal: $${order.total}\nPayment Status: Confirmed\n\nView: ${orderLink}`, appName).catch(err => {
                        console.log('Email send failed (non-critical):', err);
                      });
                  }
                });
              });
          }
          if (payload.data.crypto) {
            order.payment = payload.data.crypto;
            fbBase
              .collection("orders")
              .doc(payload.id)
              .update(validateFirebasePath(order))
              .then(() => {
                mu.setState(store().state, {
                  prop: "orders",
                  prop2: payload.id,
                  val: order,
                });
              });
          }
          return orderData.data();
        });
    },
    msgs: async (payload) => {
      let dateid = Date.now();
      var msgRef = fbBase.collection(payload.type).doc(payload.mId);
      return msgRef.get().then(async (msgData) => {
        var msg = msgData.data();
        if (!msg) {
          console.error('[UPDATE] Message document does not exist:', payload.mId);
          return null;
        }
        if (payload.topic && payload.topic !== msg.topic) {
          msg.topic = payload.topic;
          return msgRef.update(validateFirebasePath(msg));
        }
        msg.banter[dateid] = { text: payload.text, user: payload.userId || st.auth.uid };
        msg.users.forEach((user) => {
          if (user === store().state.auth.uid) {
            fbBase
              .collection("user")
              .doc(user)
              .update(
                validateFirebasePath({
                  [`msgs.${payload.mId}`]: "unseen",
                })
              );
          } else {
            fbBase
              .collection("user")
              .doc(user)
              .update(
                validateFirebasePath({
                  [`msgs.${payload.mId}`]: t,
                })
              );
          }
        });

        return msgRef.update(validateFirebasePath(msg)).then(() => {
          return dateid;
        });
      });
    },
    notifications: async (payload) => {
      var notifyRef = fbBase.collection(payload.type).doc(payload.id);
      payload.data.actions = payload.data.actions || [];
      notifyRef.update(validateFirebasePath(payload.data));
      Vue.set(st.notifications[payload.id], payload.data);
    },
    user: async (payload) => {
      // mu.log('user update, no reload', payload.data)
      payload.id = payload.id || store().state.auth.uid;
      payload.data.timestamps = payload.data.timestamps || [];
      payload.data.timestamps.push(Date.now());
      var userUpdateRef = fbBase.collection(payload.type).doc(payload.id);
      var userPrivateUpdateRef = fbBase
        .collection(payload.type)
        .doc(payload.id)
        .collection("private")
        .doc("content");
      payload.data = Object.fromEntries(
        Object.entries(payload.data).filter((x) => x[1])
      );
      userPrivateUpdateRef.set(payload.data);
      userUpdateRef.update(validateFirebasePath(payload.data));

      if (
        payload.data.basics &&
        payload.data.basics.name !== store().state.auth.name
      ) {
        var username = fb.auth().currentUser;
        username &&
          username.updateProfile({
            displayName: payload.data.basics.name,
          });
      }

      if (
        payload.data.basics &&
        payload.data.basics.email &&
        store().state.auth.email !== payload.data.basics.email
      ) {
        var userEm = fb.auth().currentUser;
        if (userEm) {
          try {
            // Firebase requires recent authentication before updating email
            // Get password from payload or prompt user
            const password = payload.password || payload.data.password || prompt("Please enter your password to update your email address:");
            
            if (!password) {
              throw new Error("Password required to update email address");
            }
            
            // Create credential for re-authentication
            const emailCredential = fb.auth.EmailAuthProvider.credential(
              userEm.email,
              password
            );
            
            // Re-authenticate the user
            await userEm.reauthenticateWithCredential(emailCredential);
            console.log("User re-authenticated successfully");
            
            // Now update the email
            await userEm.updateEmail(payload.data.basics.email);
            console.log("Email updated successfully to:", payload.data.basics.email);
            
            // Update localStorage
            window.localStorage.setItem("email", payload.data.basics.email);
            
            // Reload user to get updated email
            await userEm.reload();
            
            // Update auth state with new email
            const updatedAuth = JSON.parse(JSON.stringify(userEm));
            store().commit("setState", {
              prop: "auth",
              val: updatedAuth,
            });
            window.localStorage.setItem("auth", JSON.stringify(updatedAuth));
            
            console.log("Auth state updated with new email:", updatedAuth.email);
          } catch (error) {
            console.error("Error updating email:", error);
            console.error("Error code:", error.code);
            console.error("Error message:", error.message);
            
            // If email update fails, remove email from payload so it doesn't get saved to Firestore
            if (payload.data.basics) {
              delete payload.data.basics.email;
            }
            
            // Show user-friendly error message
            if (error.code === 'auth/requires-recent-login') {
              throw new Error("Please log out and log back in, then try updating your email again.");
            } else if (error.code === 'auth/wrong-password') {
              throw new Error("Incorrect password. Please try again.");
            } else {
              throw error;
            }
          }
        }
      }

      return userUpdateRef.get().then((data) => {
        if (!data.exists) {
          return console.error("no data", data);
        }
        return (async () => {
          var user = data.data();
          var oldUser = JSON.parse(JSON.stringify(user)); // Store old user data for indexer
          payload.data.basics &&
            Object.keys(payload.data.basics).forEach((key) => {
              if (
                !payload.data.basics[key] ||
                (payload.type === "user" && key === "user")
              ) {
                delete payload.data.basics[key];
              } else {
                user[key] = payload.data.basics[key];
              }
            });
          mu.setState(store().state, {
            prop: store().state.auth.uid === payload.id ? "user" : "users",
            prop2: payload.id,
            val: user,
          });
          mu.setState(store().state, {
            prop: "users",
            prop2: payload.id,
            val: user,
          });
          mu.setState(store().state, {
            prop: "userlist",
            val: store().state.users,
          });
          // await userUpdateRef.update(user)

          // Clean up old ref entries for this user
          if (store().state.ref && store().state.ref.name) {
            Vue.delete(store().state.ref.name, payload.id);
          }
          if (store().state.ref && store().state.ref.image) {
            Vue.delete(store().state.ref.image, payload.id);
          }

          // Then index new entries
          store().dispatch("indexer", [user, payload.id, "user", oldUser]);
          return user;
        })();
      });
    },
    comments: async (payload) => {
      var commentRef = fbBase
        .collection(payload.type)
        .doc(payload["commentsid"]);
      commentRef
        .update(validateFirebasePath({ [payload.id]: payload }))
        .then(() => {
          Vue.set(
            st.componentKeys,
            "comments",
            st.componentKeys.comments + 1
          );
          Vue.set(st.comments[payload["commentsid"]][payload.id], {});
          Vue.set(st.comments[payload["commentsid"]][payload.id], payload);
        });
    },
    keys: async (payload) => {
      console.log("updating keys", payload);
      return fbusersbase
        .collection(store().state.auth.uid)
        .doc("keys")
        .set(payload.keys);
    },
    files: async (payload) => {
      console.log("updating file", payload);
      return fbusersbase
        .collection(store().state.auth.uid)
        .doc("files")
        .set({ [payload.hash]: payload.data }, { merge: t });
    },
    any: async (payload) => {
      console.log("general update", payload);
      const date = Date.now();
      // Clean up timestamps
      if (payload.data.timestamps) {
        payload.data.created = payload.data.timestamps[0];
        delete payload.data.timestamps;
      }
      const olditem = await fbBase
        .collection(payload.type)
        .doc(payload.id)
        .get()
        .then((i) => i.data());
      console.log({ olditem });
      
      if (!olditem) {
        console.error("Item not found for update:", payload.id);
        return;
      }
      
      if (olditem.timestamps) {
        delete olditem.timestamps;
      }
      
      // Preserve original user id if admin is editing
      const isAdmin = store().state.app.advanced.roles.admin &&
        store().state.app.advanced.roles.admin.members &&
        store().state.app.advanced.roles.admin.members.includes(store().state.auth.uid);
      
      if (isAdmin && olditem.user && payload.type !== "user") {
        // Preserve the original user id when admin edits
        payload.data.user = olditem.user;
      }
      
      // payload.data.history = payload.data.history || {}
      // const dif = JSON.parse(JSON.stringify(diff(olditem, payload.data)))
      // dif && Vue.set(payload.data.history, date, dif)
      payload.data.edited = date;
      const FieldValue = fb.firestore.FieldValue;
      const updateData = JSON.parse(JSON.stringify(payload.data));
      
      // Clean up component helper properties (similar to comments)
      if (updateData.components && Array.isArray(updateData.components)) {
        updateData.components.forEach(c => {
          delete c._selectedProp;
          delete c._propValue;
          delete c._stylesText;
        });
      }
      
      const deletions = {};
      
      // Recursively find null values in nested objects and mark for deletion
      // We need to find nulls BEFORE we mutate the object
      const findNulls = (obj, path = '') => {
        if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
          const keys = Object.keys(obj);
          keys.forEach(key => {
            const currentPath = path ? `${path}.${key}` : key;
            const value = obj[key];
            if (value === null) {
              deletions[currentPath] = FieldValue.delete();
            } else if (value && typeof value === 'object' && !Array.isArray(value)) {
              findNulls(value, currentPath);
            }
          });
        }
      };
      findNulls(updateData);
      
      // Now remove nulls from updateData after we've found all of them
      const removeNulls = (obj) => {
        if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
          Object.keys(obj).forEach(key => {
            if (obj[key] === null) {
              delete obj[key];
            } else if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
              removeNulls(obj[key]);
            }
          });
        }
      };
      removeNulls(updateData);
      
      // Convert dot-notation paths to nested objects for Firestore
      const buildNestedDeletions = (paths) => {
        const result = {};
        paths.forEach(path => {
          const keys = path.split('.');
          let current = result;
          for (let i = 0; i < keys.length - 1; i++) {
            if (!current[keys[i]]) {
              current[keys[i]] = {};
            }
            current = current[keys[i]];
          }
          current[keys[keys.length - 1]] = FieldValue.delete();
        });
        return result;
      };
      
      const nestedDeletions = buildNestedDeletions(Object.keys(deletions));
      
      // Remove empty values from updateData (but keep nulls already handled above)
      Object.keys(updateData).forEach((key) => {
        if ((!updateData[key] && updateData[key] !== 0 && updateData[key] !== false && updateData[key] !== null) || (payload.type === "user" && key === "user")) {
          delete updateData[key];
        }
      });
      
      return store()
        .dispatch("indexer", [
          updateData,
          payload.id,
          payload.type,
          olditem,
        ])
        .then(() => {
          return fbBase
            .collection(payload.type)
            .doc(payload.id)
            .set(updateData, { merge: t })
            .then(() => {
              // Apply deletions if any
              if (Object.keys(nestedDeletions).length > 0) {
                return fbBase
                  .collection(payload.type)
                  .doc(payload.id)
                  .update(nestedDeletions)
                  .then(() => {
                    if (
                      payload.type !== "user" &&
                      payload.type !== "app" &&
                      payload.type !== "orders" &&
                      payload.type !== "sales"
                    ) {
                      return store().dispatch("query", {
                        type: "item",
                        collection: payload.type,
                        id: payload.id,
                      });
                    }
                  });
              } else {
                if (
                  payload.type !== "user" &&
                  payload.type !== "app" &&
                  payload.type !== "orders" &&
                  payload.type !== "sales"
                ) {
                  return store().dispatch("query", {
                    type: "item",
                    collection: payload.type,
                    id: payload.id,
                  });
                }
              }
            });
        });
    },
  };
  methods[
    Object.keys(methods).includes(payload.type) ? payload.type : "any"
  ](payload);
}

export { update };

